<template lang="pug">
    v-dialog(v-model="dialog" persistent max-width="400")
      v-card
        v-toolbar(flat justify-end text-right)
          v-spacer
          v-toolbar-title(class="font-weight-bold error--text mr-6") Timeout
        v-card-text(class="font-weight-medium text-center mt-2" ) 
          v-layout
            v-flex(lg3 md3 xs3) 
              v-icon(class="error--text"  x-large) mdi-timer-sand
            v-flex(lg9 md9 xs9) 
              div {{ dialogMessage }}
              div Silahkan login kembali.
        v-card-actions(class="justify-center" )
          v-btn(color="error" class="mb-3" width="150px" style="font-size:10px" @click="doLogout") Kembali Login
</template>
<script>

import { mapMutations } from "vuex";
import localforage from "localforage";

export default {
  name: "FDialogTimeout",
  props: ["username", "value"],
  data() {
    return {
      dialog: false,
      interval: null,
      dialogMessage: "Anda tidak diizinkan mengakses halaman ini atau sesi login anda telah berakhir."
    };
  },
  watch: {
    value(val) {
      this.doInitModel(val);
    }
  },
  mounted() {
    this.doInitModel(this.value);
  },
  methods: {
    ...mapMutations(["progress"]),
    doInitModel(values) {
      this.dialog = values ? values : "";
      if (this.dialog) {
        clearInterval(this.interval);
        this.interval = setInterval(() => {
            this.doLogout();
        }, 5000);
      }

    },
    doLogout() {
      this.dialog = false;
      this.$progress.show(true);

      this.$http.get("/api/sec/logout", {params: {username: this.username}}).then(
        success => {
          this.$session.clear();
          if(this.$socket.isStarted()){
            this.$socket.deactivate();
          } 
          
          this.$router.push({ name: "login" }).catch(err => {});
        },
        err => {
          this.$session.clear();
          if(this.$socket.isStarted()){
            this.$socket.deactivate();
          } 
          
          this.$router.push({ name: "login" }).catch(err => {});
        }
      ).finally(() => this.$progress.show(false), clearInterval(this.interval));
    },
    closeDialog(){
      this.dialog = false;
      this.$emit("dialog", false);
    }
  }
};
</script>